import { useState } from 'react'

export const Protection = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalImage, setModalImage] = useState()

    const handleOpenModal = (imageNumber) => {
        setModalImage(imageNumber)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }
    return (
        <>
            <div className='max-w-[1200px] mx-auto'>
                <div className='flex justify-center mt-12 '>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-protection-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        <span className='text-pborange'>Protection</span> est une capacité spéciale que peuvent utiliser
                        certains personnages ou objets de la carte. Elle est indiquée par une ligne flottante reliant
                        tout ce qui peut l'utiliser. En utilisant Protection, vous pourrez élaborer des stratégies
                        encore plus poussées lors des combats !
                    </p>{' '}
                    <div className=''>
                        <div className='mt-8 w-full md:w-4/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal(1)
                                }}
                                className='ss-thumb max-w-full'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-1-s.webp`}
                            />{' '}
                        </div>{' '}
                        <p className='mt-8'>
                            Différents types de Protections affectent toute une gamme d'éléments, par exemple en
                            ajoutant un multiplicateur de 0 % à la cible lorsqu'elle attaque (puissance d'attaque +x %),
                            en diminuant la DÉF de la cible de x %, (DÉF - x %), en empêchant la cible de se déplacer
                            au-delà de sa position actuelle, en bloquant certaines actions, en augmentant les dégâts
                            Hors Zone de x % (dégâts Hors Zone +x %), en forçant les ennemis situés dans la zone de
                            déplacement d'un personnage à le cibler, et bien plus encore.
                        </p>{' '}
                        <div className='mt-8 w-full md:w-4/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal(2)
                                }}
                                className='ss-thumb'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-2-s.webp`}
                            />{' '}
                            <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                                Découvrez les effets de Protection en faisant passer le curseur au-dessus d'un
                                personnage sur la carte.
                            </p>
                        </div>
                    </div>{' '}
                    <p className='mt-8'>
                        Si vous <span className='text-pborange'>détruisez</span> un objet ou un personnage qui déclenche
                        Protection, son <span className='text-pborange'>effet disparaît</span>. En revanche, si vous{' '}
                        <span className='text-pborange'>
                            combinez un allié avec la source d'une Protection, l'allié gagnera cette Protection
                        </span>
                        . N'hésitez pas à tester toutes les manières de l'exploiter en cours de combat !
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal(3)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-3-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Il est impossible de pénétrer dans une certaine zone de la carte sans en retirer la
                            Protection Avancée impossible. En effet, les Protections n'affectent pas seulement vous ou
                            vos alliés, mais peuvent aussi s'étendre à la carte elle-même.
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        Par exemple, imaginons qu'une roche sur la carte déclenche une Protection qui confère Puissance
                        d'attaque +10 % aux ennemis et à l'herbe. Cette Protection, visible grâce aux lignes lumineuses
                        qui les relient, est synonyme de mauvaise nouvelle. Dans ce genre de situation, détruire la
                        roche à l'origine de cette Protection fera disparaître l'effet dont bénéficient les ennemis. En
                        revanche, si vous combinez un allié avec l'herbe qui bénéficie de la Protection, ou à la roche
                        qui en est à l'origine, l'effet Puissance d'attaque +10 % conféré par cette Protection sera
                        attribué à cet allié. À vous de décider de la meilleure stratégie !
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal(4)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-4-s.webp`}
                        />{' '}
                    </div>{' '}
                </div>{' '}
                <div
                    onClick={handleCloseModal}
                    className={`z-50 fixed top-0 left-0 w-full h-full bg-black/80 ${showModal ? 'block' : 'hidden'}`}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className='w-full md:w-[80%] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 m-auto z-30'
                    >
                        <div className='flex flex-row items-center mx-auto md:gap-4'>
                            <div>
                                {modalImage > 1 && modalImage < 5 ? (
                                    <button onClick={() => setModalImage(modalImage - 1)} className=''>
                                        <img
                                            className='w-full min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                            alt={`right`}
                                        />{' '}
                                    </button>
                                ) : (
                                    <button>
                                        <img
                                            className='w-full brightness-50 min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                            alt={`left`}
                                        />
                                    </button>
                                )}
                            </div>

                            <div className='relative'>
                                <button
                                    onClick={handleCloseModal}
                                    className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                                >
                                    <img className='' src={`${process.env.PUBLIC_URL}/images/close.png`} alt='close' />{' '}
                                </button>
                                <img
                                    className='white-drop-shadow max-w-[1920px] mx-auto w-full'
                                    src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-${modalImage}.webp`}
                                    alt={`screen shot of game system`}
                                />{' '}
                            </div>

                            <div>
                                {modalImage === 4 ? (
                                    <button>
                                        <img
                                            className='w-full brightness-50 min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                            alt='right'
                                        />
                                    </button>
                                ) : (
                                    <button onClick={() => setModalImage(modalImage + 1)} className=' '>
                                        <img
                                            className='w-full min-w-[30px]'
                                            src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                            alt='right'
                                        />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>{' '}
            </div>
        </>
    )
}
